module.exports = __webpack_public_path__ + "static/img/2.520c201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/VTS/2.png
// module id = QXRc
// module chunks = 1